import { render, staticRenderFns } from "./RatesDistanceDetails.vue?vue&type=template&id=313cf43a&scoped=true&"
import script from "./RatesDistanceDetails.vue?vue&type=script&lang=js&"
export * from "./RatesDistanceDetails.vue?vue&type=script&lang=js&"
import style0 from "./RatesDistanceDetails.vue?vue&type=style&index=0&id=313cf43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313cf43a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313cf43a')) {
      api.createRecord('313cf43a', component.options)
    } else {
      api.reload('313cf43a', component.options)
    }
    module.hot.accept("./RatesDistanceDetails.vue?vue&type=template&id=313cf43a&scoped=true&", function () {
      api.rerender('313cf43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/RatesDistanceDetails.vue"
export default component.exports